export enum ThroughputReportTimePeriod {
  QUARTERLY = "quarterly",
  MONTHLY = "monthly",
  WEEKLY = "weekly",
  DAILY = "daily",
}
